import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_ProgramService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String): Observable<Array<PM_Program_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram?token=" + Token).pipe(
      map(data => {
        return data as Array<PM_Program_Interface>
      })
    )
  }

  GetActive(Token: String): Observable<Array<PM_Program_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<PM_Program_Interface>
      })
    )
  }

  AddEditPM(
    model: PM_Program_Interface,
    Item:Array<number>,
    userId:Array<number>,
    Token: String): Observable<PM_Program_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelBody = {
      id: model.id,
      title: model.title,
      duration_id: model.duration_id,

    }

    var body = {
      model: modelBody,
      items : Item,
      userId : userId,
      token: Token
    }

    return this.http.post(environment.BaseUrl + "Daro/PMProgram/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as PM_Program_Interface
      })
    )

  }




  DeletePM(id: number, Token: String): Observable<PM_Program_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/PMProgram/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as PM_Program_Interface
      })
    )

  }


  GetUser(id: number,Token: String): Observable<Array<User_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram/GetUser?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Array<User_Interface>
      })
    )
  }


}
